import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { APP_INITIALIZER, ModuleWithProviders, NgModule, Provider, inject, makeEnvironmentProviders, provideAppInitializer } from "@angular/core";
import { LoggerInterceptor } from ".";
import { LoggerConfig } from "./logger.config";
import { LoggerService } from "./logger.service";

@NgModule({
  declarations: [],
  imports: [CommonModule]
})
export class LoggerModule {
  static forRoot(config: LoggerConfig): ModuleWithProviders<LoggerModule> {
    return {
      ngModule: LoggerModule,
      providers: createProviders(config)
    };
  }
}

function createProviders(config: LoggerConfig) {

  let providers: Provider[] = [
    {
      provide: APP_INITIALIZER,
      useFactory: () => {
        const logger = inject(LoggerService);
        return () => {
          LoggerService.logDebug = false;
        };
      },
      deps: [],
      multi: true
    }
  ];

  if (config.useInterceptor) {
    providers = [
      ...providers,
      {
        provide: HTTP_INTERCEPTORS,
        useClass: LoggerInterceptor,
        multi: true
      }
    ];
  }
  return providers;
}
